﻿$.fn.dxCtrlContentSondageSaisie = function custom_dxCtrlContentSondageSaisie(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentsondagesaisie dx-ctrl");
        this.createInstance(new cdxCtrlContentSondageSaisie(this, option));
    }
    return this;
}

window.cdxCtrlContentSondageSaisie = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    if (typeof option.isInPopup == 'undefined') option.isInPopup = true

    function mConstruit() {
        container.empty();

        var dataSondageReponse = null
        if (!option.idSondageReponse || option.idSondageReponse == "0") {
            dataSondageReponse = option.bddCtrl.getObjet("sondage_reponse").mGetNewData()
            dataSondageReponse.id_sondage = option.dataSondage.id_sondage
            dataSondageReponse.id_table_destinataire = toPositiveInt(option.idTableDest)
            dataSondageReponse.id_destinataire = toPositiveInt(option.idDest)

            if (option.ignoreSave) {
                mInit()
            } else {
                option.bddCtrl.getObjet(dataSondageReponse).mSave(function (data) {
                    mInit()
                })
            }
        } else {
            dataSondageReponse = option.bddCtrl.getObjet("sondage_reponse", option.idSondageReponse).data
            mInit()
        }

        function mInit() {
            var sondageReponse = new cSondageReponse({
                bddCtrl: option.bddCtrl,
                dataSondage: option.dataSondage,
                dataSondageReponse: dataSondageReponse,
                ignoreSave: option.ignoreSave
            })
            var lstItem = []
            sondageReponse.sondage.jsonQuestion.lst_page.forEach(function (page) {
                lstItem.push($("<div/>").dxCtrlWizardAnimItemType({
                    bddCtrl: option.bddCtrl,
                    forcePhone: option.forcePhone,
                    dxItem:
                        $("<div/>").dxCtrlContentSondageSaisiePage({
                            bddCtrl: option.bddCtrl,
                            sondageReponse: sondageReponse,
                            dataPage: page
                        }).dxCtrlContentSondageSaisiePage("instance")
                }).dxCtrlWizardAnimItemType("instance"))
            })
            lstItem.push($("<div/>").dxCtrlWizardAnimItemType({
                bddCtrl: option.bddCtrl,
                forcePhone: option.forcePhone,
                dxItem:
                    $("<div/>").dxCtrlContentSondageSaisiePage({
                        bddCtrl: option.bddCtrl,
                        sondageReponse: sondageReponse,
                        dataPage: sondageReponse.sondage.jsonFin
                    }).dxCtrlContentSondageSaisiePage("instance")
            }).dxCtrlWizardAnimItemType("instance"))

            container.dxCtrlWizardAnim({
                bddCtrl: option.bddCtrl,
                isInPopup: option.isInPopup,
                showClose: option.showClose,
                lstItem: lstItem,
                forcePhone: option.forcePhone,
                indexSelectedPage: option.indexSelectedPage,
                isInPage: option.isInPage
            })
        }

    }

    this.element = function () { return container; }
    this.component = function () { return Me; }

    mConstruit();
}